export default __webpack_public_path__ + "static/media/901.24cbfdd3.gif";